import { qltClient } from '../clients';
import { Repository } from '../core/repository';
import type { QueryParams } from '../core/params';
import type { QltClass } from '../types';

export const ClassRepository = {
  ...Repository<QltClass>(qltClient, '/classes'),
  getSimpleClasses: (params?: QueryParams) =>
    qltClient.get('/getSimpleClasses', { params }).then((res) => res.data as QltClass[]),
};

export default ClassRepository;
